import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { IconButton, Stack, Typography } from '@mui/material';
import classnames from 'classnames';
import React, { memo, useMemo, useRef, useState } from 'react';
import useBackwardsCompatible from '../../../../../hooks/useBackwardsCompatible';
import theme from '../../../../../theme';
import { Dashboard } from '../../../../../types/files';
import SelectDealOwnerModalNew from '../../../../modals/home-table-view/SelectDealOwnerModalNew';
import useStyles from "../styles";

const OwnerCell: React.FC<{ dashboard: Dashboard, expander?: boolean }> = ({ dashboard, expander }) => {
    const classes = useStyles();
    const { dashboardOwner } = useBackwardsCompatible();
    const [fieldHover, setFieldHover] = useState<boolean>(expander || false);
    const [editModalOpen, setEditModalOpen] = useState<boolean>(false);
    const dealOwnerRef = useRef<HTMLElement>(null);

    const owner = useMemo(() => dashboardOwner(dashboard), [dashboard, dashboardOwner]);
    const initials = useMemo(() =>
        owner?.name ? owner.name.split(' ').slice(0, 2).map(word => word.charAt(0).toUpperCase()).join('') : ''
    , [owner]);

    return (<>
        <Stack width="100%" ref={dealOwnerRef} onMouseLeave={() => setFieldHover(expander || false)}>
            <Stack direction="row" alignItems="center" justifyContent="space-between" width="100%"
                onMouseEnter={() => setFieldHover(true)}>
                <Stack direction="row" spacing={1} alignItems="stretch" justifyContent="flex-start">
                    {(!!owner?.name || !!owner?.email) ? (<>
                        {!!initials && (
                            <Stack alignItems="center" justifyContent="center" p={2} width={32} height={32}
                                sx={{ borderRadius: 4, background: 'linear-gradient(90deg, #2dd4bf 0%, #0d9488 100%)' }}>
                                <Typography fontSize="0.75rem" fontWeight={600} fontFamily="Lato" color="#fff">
                                    {initials || ''}
                                </Typography>
                            </Stack>
                        )}
                        <Stack direction="column" alignItems="flex-start" justifyContent="center">
                            {!!owner?.name && (
                                <Typography fontFamily="Lato"
                                    fontWeight={expander ? 700 : 400}
                                    fontSize="0.95rem"
                                    color="#334155"
                                    // sx={{ "&:hover": { textDecoration: expander ? 'none' : 'underline' }, cursor: 'pointer' }}
                                > {owner?.name}
                                </Typography>
                            )}
                        </Stack>
                    </>) : expander ? (
                        <Typography fontSize={15} fontWeight={500}>
                            {'No deal owner'}
                        </Typography>
                    ) : (
                        <Typography className={classnames(classes.label, classes.sublabel)} pl={4}>
                            {'No deal owner'}
                        </Typography>
                    )}
                    </Stack>
                    {fieldHover && (
                        <Stack direction="row" alignItems="stretch" justifyContent="flex-end">
                            <IconButton disableRipple
                                onClick={() => setEditModalOpen(true)}
                                sx={{ padding: 'unset !important'}}>
                                <ExpandMoreIcon className={classes.icon} sx={{ fill: theme.colors.neutral['500'] }} />
                            </IconButton>
                        </Stack>
                    )}
            </Stack>
        </Stack>
        {editModalOpen && (
            <SelectDealOwnerModalNew
                open={editModalOpen}
                dashboard={dashboard}
                anchorElement={dealOwnerRef.current}
                onClose={() => setEditModalOpen(false) } />
        )}
    </>);
}

export default memo(OwnerCell);